import React from "react";
import { Container, Image } from "react-bootstrap";
import "./Second.css";
import Slider from "react-slick";
import img1 from "../../../../Asset/lifeatweb/card-img-1.webp";
import img2 from "../../../../Asset/lifeatweb/card-img-2.webp";
import img3 from "../../../../Asset/lifeatweb/card-row2-img-1.webp";
import img4 from "../../../../Asset/lifeatweb/card-row2-img-2.webp";
import img5 from "../../../../Asset/lifeatweb/card-row3-img-1.webp";
import img6 from "../../../../Asset/lifeatweb/card-row3-img-2-1.webp";
import img7 from "../../../../Asset/lifeatweb/card-row4-img-1.webp";
import img8 from "../../../../Asset/lifeatweb/card-row4-img-2.webp";
import img9 from "../../../../Asset/lifeatweb/card-row4-img-3.webp";
import img10 from "../../../../Asset/lifeatweb/card-row4-img-4.webp";
import img11 from "../../../../Asset/lifeatweb/card-row5-img-1.webp";
import img12 from "../../../../Asset/lifeatweb/card-row5-img-2.webp";
import img13 from "../../../../Asset/lifeatweb/card-row6-img-1.webp";
import img14 from "../../../../Asset/lifeatweb/card-row6-img-2.webp";

const Second = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 6.5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 10000,
    autoplaySpeed: 1000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3.5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.8,
        },
      },
      {
        breakpoint: 912,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.1,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3.2,
        },
      },
    ],
  };

  return (
    <>
      <section className="second-sec-lifeat">
        <Container>
          <div className="top-text-second-lifeat">
            <h2>
              IMAGE <span> GALLERY</span>
            </h2>
          </div>
          <h3>
            Wanna get the Feel of Our
            <strong className="text-skyblue"> Happy Hours at Work</strong> ?
          </h3>
          <div>
            <h5>
              We take pride in Our Work Joy in Our Play. Celebrations are
              Integral part of Our Culture.
            </h5>
          </div>
        </Container>

        {/* <div className="wo-img-gallery-row">
          <div className="slider-container ">
            <Slider {...settings}>
              <div className="gallery-wrapper">
                <div className="gallery-image-card-1">
                  <div className="col-1-img-1 image-1">
                    <Image src={img1} alt="Gallery Image 1" />
                  </div>
                  <div className="col-1-img-2 image-2">
                    <Image src={img2} alt="Gallery Image 2" />
                  </div>
                </div>
              </div>
              <div className="gallery-wrapper">
                <div className="gallery-image-card-1">
                  <div className="col-2-img-1 image-1">
                    <Image src={img3} alt="Gallery Image 3" />
                  </div>
                  <div className="col-2-img-2 image-2">
                    <Image src={img4} alt="Gallery Image 4" />
                  </div>
                </div>
              </div>
              <div className="gallery-wrapper">
                <div className="gallery-image-card-1">
                  <div className="col-3-img-1 image-1">
                    <Image src={img5} alt="Gallery Image 5" />
                  </div>
                  <div className="col-3-img-2 image-2">
                    <Image src={img6} alt="Gallery Image 6" />
                  </div>
                </div>
              </div>
              <div className="gallery-wrapper big-row">
                <div className="gallery-image-card-1">
                  <div className="col-4-img-1 image-1">
                    <Image src={img7} alt="Gallery Image 7" />
                  </div>
                  <div className="image-2 gallery-row-4">
                    <div className="image-row-4">
                      <Image
                        src={img8}
                        alt="Gallery Image 8"
                        className="img-l"
                      />
                    </div>
                    <div className="image-row-4">
                      <Image
                        src={img9}
                        alt="Gallery Image 9"
                        className="img-r"
                      />
                    </div>
                  </div>
                  <div className="image-3">
                    <Image src={img10} alt="Gallery Image 10" />
                  </div>
                </div>
              </div>
              <div></div>
              <div className="gallery-wrapper">
                <div className="gallery-image-card-1">
                  <div className="col-5-img-1 image-1">
                    <Image src={img11} alt="Gallery Image 11" />
                  </div>
                  <div className="col-5-img-2 image-2">
                    <Image src={img12} alt="Gallery Image 12" />
                  </div>
                </div>
              </div>
              <div className="gallery-wrapper">
                <div className="gallery-image-card-1">
                  <div className="col-6-img-1 image-1">
                    <Image src={img13} alt="Gallery Image 13" />
                  </div>
                  <div className="col-6-img-2 image-2">
                    <Image src={img14} alt="Gallery Image 14" />
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div> */}
      </section>
    </>
  );
};

export default Second;
